import axios from 'axios';

const ptUrl = process.env.PT_URL || '[NOT DEFINED: PT_URL]'
const url = '/api/v1/external/pushover';

class LocalPushoverService {

	static messageSimple(message, userApiKey, token) {
		
		return this.message({
			user: userApiKey,
			title: 'A Message from Principal Task',
			message: message,
			url: ptUrl,
			url_title: 'Principal Task Website'
		}, token)
	}
	

	static message(messageObj, token) {
		
		return axios.post(url + '/message', {
			message: messageObj
		},
		{
			headers: {Authorization: `Bearer ${token}`}
		})
	}
	
	static validate(apiKey, token) {
		
		return axios.post(url + '/validate', {
		    user: apiKey
		},
		{
		    headers: {Authorization: `Bearer ${token}`}
		}) 
	}

}

export default LocalPushoverService; 